import { useQuery } from "react-query"
import MessageService from "~services/MessageService"

const useCompanyMessages = (id: string, options?) => {
  return useQuery(
    "company-messages",
    () => MessageService.getMessagesByCompany(id, options),
    {
      enabled: false,
    }
  )
}

export default useCompanyMessages
